import { render, staticRenderFns } from "./explore-article-tile.vue?vue&type=template&id=62a00bb4&"
import script from "./explore-article-tile.vue?vue&type=script&lang=js&"
export * from "./explore-article-tile.vue?vue&type=script&lang=js&"
import style0 from "./explore-article-tile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SgImg: require('/opt/build/repo/storefront/components/legacy/global/sg-img.vue').default,SgLink: require('/opt/build/repo/storefront/components/legacy/global/sg-link.vue').default})
